import { ViewModel, View } from "binder"
import { EmptyWindowView } from "./emptyWindow-view"
import { WindowViewModel } from "../windowContainer/windowContainer-viewModel";
import { translate } from "src/common/utilities";

export class EmptyWindowViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("emptyWindow-viewModel.confirmationWindow", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View<ViewModel> {
        return new EmptyWindowView();
    }
    public getTypeId(): string {
        return "VM-E312D559-3140-4193-A518-FA44B177833C"
    }
}
